import * as Joi from 'joi';

const AddReasonSchema = () =>
  Joi.object({
    specialConsiderationType: Joi.string().required().empty().messages({
      'any.required': `Special Consideration Type is not allowed to be empty.`,
      'string.empty': `Special Consideration Type is not allowed to be empty.`,
    }),
    reason: Joi.string().required().empty().messages({
      'any.required': `Reason is not allowed to be empty.`,
      'string.empty': `Reason is not allowed to be empty.`,
    }),
    explanation: Joi.string().required().empty().max(500).messages({
      'string.empty': 'Explanation is not allowed to be empty.',
      'string.max': 'Explanation is too long.',
      'any.required': 'Explanation is not allowed to be empty.',
    }),
  });

export default AddReasonSchema;
